import React from 'react';
import Img from 'gatsby-image';
import { BiTime } from 'react-icons/bi';
import Fade from 'react-reveal/Fade';
import { TiDownload } from 'react-icons/ti';
import { ImLocation2 } from 'react-icons/im';
import { Link } from 'gatsby';

function ProjectCard({ project }) {
  const { id, title, category, imageOne, date, slug, capacity, location } = project;

  return (
    <Fade right>
      <div className='project-card'>
        <Img style={{ height: '250px' }} fluid={imageOne.fluid} objectFit='cover' alt={title} />
        <div className='project-details'>
          <Link to={`/projects/${slug}`} className='title'>
            {title}
          </Link>
          <span className='category'>{category}</span>
          <div className='date d-flex align-items-center'>
            <div className='mb-2 mt-2'>
              <div className='mb-2'>
                <TiDownload className='mr-2 date-icon' />
                <span>{capacity}</span>
              </div>
              <div className='mb-2'>
                <BiTime className='mr-2 date-icon' />
                <span>{date}</span>
              </div>
              <div className='mb-2'>
                <ImLocation2 className='mr-2 date-icon' />
                <span>{location}</span>
              </div>
            </div>
          </div>
          <Link to={`/projects/${slug}`} className='link'>
            Read More..
          </Link>
        </div>
      </div>
    </Fade>
  );
}

export default ProjectCard;
